import { Repository } from "../../adapters/repository";
import { IconExtractor } from "../../adapters/iconExtractor";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: Repository,
  extractor: IconExtractor,
): Interactor {
  return ({ project, link }) =>
    present(
      repository
        .saveProjectExternalLink(project, link)
        .then(() =>
          extractor
            .extractIcon(link)
            .then((icon) => ({ project, link: { ...link, icon } })),
        )
        .catch(() =>
          Promise.reject({
            project,
            link,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
